import { cloneElement, ElementType, isValidElement } from "react";
import EXTERNAL_LINK_PROPS from "../../util/externalLinkProps";
import StyledFireButton from "./StyledFireButton";
import { FireButtonProps, scales, variants } from "./types";

const SetOnFire = <E extends ElementType = "button">(props: FireButtonProps<E>): JSX.Element => {
  const { startIcon, endIcon, external, className, isLoading, disabled, children, ...rest } = props;
  const internalProps = external ? EXTERNAL_LINK_PROPS : {};
  const isDisabled = isLoading || disabled;
  const classNames = className ? [className] : [];

  if (isLoading) {
    classNames.push("donaswap-button--loading");
  }

  if (isDisabled && !isLoading) {
    classNames.push("donaswap-button--disabled");
  }

  return (
    <StyledFireButton
      $isLoading={isLoading}
      className={classNames.join(" ")}
      disabled={isDisabled}
      {...internalProps}
      {...rest}
    >
      <>
        {isValidElement(startIcon) &&
          cloneElement(startIcon, {
            // @ts-ignore
            mr: "0.5rem",
          })}
        {children}
        {isValidElement(endIcon) &&
          cloneElement(endIcon, {
            // @ts-ignore
            ml: "0.5rem",
          })}
      </>
    </StyledFireButton>
  );
};

SetOnFire.defaultProps = {
  isLoading: false,
  external: false,
  // variant: variants.PRIMARY,
  variant: variants.SETONFIRE,
  scale: scales.MD,
  disabled: false,
};

export default SetOnFire;
